import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = { class: "min-h-screen bg-gray-50" };
const _hoisted_2 = { class: "mx-auto max-w-7xl px-6 py-10" };
const _hoisted_3 = {
    key: 0,
    class: "flex flex-col items-center justify-center py-24 text-center text-gray-500"
};
const _hoisted_4 = {
    key: 1,
    class: "py-24 text-center"
};
const _hoisted_5 = { class: "text-2xl font-semibold text-gray-800" };
const _hoisted_6 = {
    key: 2,
    class: "grid gap-12 lg:grid-cols-[1fr_1fr]"
};
const _hoisted_7 = { class: "w-full" };
const _hoisted_8 = { class: "relative overflow-hidden rounded-2xl bg-white shadow-sm w-full max-w-sm mx-auto lg:max-w-full" };
const _hoisted_9 = { class: "aspect-square p-4" };
const _hoisted_10 = ["src", "alt"];
const _hoisted_11 = {
    key: 1,
    class: "flex h-full flex-col items-center justify-center text-gray-400"
};
const _hoisted_12 = {
    key: 0,
    class: "mt-4 grid grid-cols-4 gap-2 max-w-sm mx-auto lg:max-w-full"
};
const _hoisted_13 = ["onClick"];
const _hoisted_14 = ["src", "onError"];
const _hoisted_15 = { class: "flex flex-col" };
const _hoisted_16 = {
    key: 0,
    class: "text-sm font-medium text-pink-600 uppercase tracking-wide"
};
const _hoisted_17 = { class: "mt-1 text-2xl font-bold text-gray-900 sm:text-3xl" };
const _hoisted_18 = { class: "mt-3 flex flex-wrap gap-2 text-sm" };
const _hoisted_19 = {
    key: 0,
    class: "inline-flex items-center rounded-full bg-gray-100 px-3 py-1 font-medium text-gray-700"
};
const _hoisted_20 = {
    key: 1,
    class: "inline-flex items-center rounded-full bg-gray-100 px-3 py-1 font-medium text-gray-600"
};
const _hoisted_21 = {
    key: 1,
    class: "mt-3 text-sm text-gray-600 sm:text-base"
};
const _hoisted_22 = {
    key: 2,
    class: "mt-3 text-sm text-gray-600 sm:text-base"
};
const _hoisted_23 = { class: "mt-5 flex flex-wrap items-baseline gap-3" };
const _hoisted_24 = { class: "text-3xl font-bold text-gray-900" };
const _hoisted_25 = {
    key: 0,
    class: "text-lg text-gray-400 line-through"
};
const _hoisted_26 = {
    key: 1,
    class: "inline-flex items-center rounded-full bg-green-100 px-2.5 py-0.5 text-xs font-semibold text-green-700"
};
const _hoisted_27 = {
    key: 3,
    class: "mt-2 text-sm text-gray-600"
};
const _hoisted_28 = { key: 0 };
const _hoisted_29 = {
    key: 4,
    class: "mt-2 text-xs uppercase tracking-wide text-gray-400"
};
const _hoisted_30 = { class: "text-gray-600" };
const _hoisted_31 = { class: "hidden mt-6" };
const _hoisted_32 = ["disabled"];
const _hoisted_33 = { key: 0 };
const _hoisted_34 = { key: 1 };
const _hoisted_35 = {
    key: 0,
    class: "mt-2 block text-center text-sm font-medium text-green-600"
};
const _hoisted_36 = {
    key: 5,
    class: "mt-10"
};
const _hoisted_37 = { class: "mt-4 flex flex-wrap gap-2" };
const _hoisted_38 = {
    key: 6,
    class: "mt-10"
};
const _hoisted_39 = { class: "mt-4 flex flex-wrap gap-2" };
const _hoisted_40 = { class: "lg:col-span-2" };
const _hoisted_41 = { class: "grid gap-10 lg:grid-cols-2" };
const _hoisted_42 = {
    key: 0,
    class: "rounded-3xl bg-white p-6 shadow-sm"
};
const _hoisted_43 = { class: "mt-4 grid grid-cols-2 gap-4 sm:grid-cols-3" };
const _hoisted_44 = { class: "text-xs font-medium uppercase tracking-wide text-gray-500" };
const _hoisted_45 = { class: "mt-2 text-2xl font-semibold text-gray-900" };
const _hoisted_46 = { class: "ml-1 text-sm font-normal text-gray-500" };
const _hoisted_47 = {
    key: 1,
    class: "rounded-3xl bg-white p-6 shadow-sm"
};
const _hoisted_48 = { class: "mt-4 text-sm leading-relaxed text-gray-600" };
const _hoisted_49 = {
    key: 0,
    class: "mt-4"
};
import { computed, onBeforeUnmount, onMounted, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useApi } from '../composables/useApi';
import { useCartStore } from '../composables/useCartStore';
import ProductConfigModal from '../components/ProductConfigModal.vue';
import ProductSlider from '../components/ProductSlider.vue';
import MoneyUtils from '../utils/MoneyUtils';
import { generateProductSlug, getCategorySlugFromProduct, getProductSlugCandidates, slugifySegment } from '../utils/productSlug';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ProductDetailsPage',
    props: {
        category: { default: '' },
        product: { default: '' },
        productId: { default: '' }
    },
    setup(__props) {
        const NUTRITION_FIELDS = [
            { key: 'calories', label: 'Kalorien', unit: 'kcal' },
            { key: 'fat', label: 'Fett', unit: 'g' },
            { key: 'carbohydrates', label: 'Kohlenhydrate', unit: 'g' },
            { key: 'protein', label: 'Eiweiß', unit: 'g' },
            { key: 'fiber', label: 'Ballaststoffe', unit: 'g' },
            { key: 'salt', label: 'Salz', unit: 'g' }
        ];
        const ALLERGEN_LABELS = {
            gluten: 'Gluten',
            lactose: 'Laktose',
            nuts: 'Schalenfrüchte',
            eggs: 'Eier',
            soy: 'Soja',
            fish: 'Fisch',
            crustaceans: 'Krebstiere',
            molluscs: 'Weichtiere',
            celery: 'Sellerie',
            mustard: 'Senf',
            sesame: 'Sesam',
            sulphites: 'Sulfite',
            peanuts: 'Erdnüsse',
            lupin: 'Lupine',
            tree_nuts: 'Schalenfrüchte'
        };
        // ✅ Use props instead of useRoute() to avoid injection issues
        const props = __props;
        // ✅ Keep route for query/hash/name access, but use props for params
        const route = useRoute();
        const router = useRouter();
        const cartStore = useCartStore();
        const { loadMenuBundle, menuItems } = useApi();
        const loading = ref(true);
        const loadError = ref(null);
        const product = ref(null);
        const imageGallery = ref([]);
        const activeImageIndex = ref(0);
        const addedFeedback = ref(false);
        const modalProduct = ref(null);
        const isConfigModalOpen = ref(false);
        let addFeedbackTimer = null;
        let loadSequence = 0;
        const currentCategorySlug = computed(() => {
            // Use props directly instead of route.params
            return props.category?.toLowerCase() || '';
        });
        const currentProductSlug = computed(() => {
            // Use props directly instead of route.params
            return props.product?.toLowerCase() || '';
        });
        const currentProductId = computed(() => {
            // Use props directly instead of route.params
            return props.productId || '';
        });
        const menuItemsList = computed(() => {
            const items = menuItems.value;
            return Array.isArray(items) ? items : [];
        });
        const productCategorySlug = computed(() => (product.value ? getCategorySlugFromProduct(product.value) : null));
        const canonicalSlug = computed(() => (product.value ? generateProductSlug(product.value) : ''));
        const brand = computed(() => product.value?.brand?.trim() ?? '');
        const weight = computed(() => product.value?.weight?.trim() ?? '');
        const ean = computed(() => product.value?.ean?.trim() ?? '');
        const shortDescription = computed(() => product.value?.shortDescription?.trim() ?? '');
        const categoryLabel = computed(() => {
            if (!product.value) {
                return '';
            }
            if (product.value.category && typeof product.value.category === 'object' && product.value.category !== null) {
                const categoryRecord = product.value.category;
                const categoryName = categoryRecord.name;
                if (typeof categoryName === 'string' && categoryName.trim()) {
                    return categoryName;
                }
            }
            if (typeof product.value.category === 'string') {
                const categoryString = product.value.category;
                // Don't display if it's a MongoDB ID (24 hex characters)
                if (/^[a-f0-9]{24}$/i.test(categoryString)) {
                    return '';
                }
                return categoryString;
            }
            if (product.value.categoryName) {
                return product.value.categoryName;
            }
            return '';
        });
        const formattedPrice = computed(() => formatPrice(product.value?.price, product.value?.priceCent));
        const formattedOriginalPrice = computed(() => formatPrice(product.value?.originalPrice, product.value?.originalPriceCent));
        const hasDiscount = computed(() => {
            if (!product.value?.priceCent || !product.value?.originalPriceCent) {
                return false;
            }
            return product.value.originalPriceCent > product.value.priceCent;
        });
        const discountPercent = computed(() => {
            if (!product.value?.priceCent || !product.value?.originalPriceCent) {
                return null;
            }
            const current = product.value.priceCent;
            const original = product.value.originalPriceCent;
            if (!Number.isInteger(current) || !Number.isInteger(original) || original <= current) {
                return null;
            }
            return Math.round((1 - current / original) * 100);
        });
        const primaryColor = computed(() => {
            // Get primary color from branding config or default
            return '#EC4899'; // Default pink, projects can override via CSS variables
        });
        const depositDisplay = computed(() => {
            const deposit = product.value?.deposit;
            if (!deposit || deposit.type === 'none' || !deposit.amountCent) {
                return null;
            }
            return {
                amount: MoneyUtils.formatCurrency(deposit.amountCent),
                label: getDepositLabel(deposit.type)
            };
        });
        const keywords = computed(() => {
            if (!product.value || !Array.isArray(product.value.keywords)) {
                return [];
            }
            const unique = new Set();
            for (const keyword of product.value.keywords) {
                if (typeof keyword === 'string' && keyword.trim()) {
                    unique.add(formatLabel(keyword));
                }
            }
            return Array.from(unique);
        });
        const allergens = computed(() => {
            if (!product.value || !Array.isArray(product.value.allergens)) {
                return [];
            }
            const unique = new Set();
            for (const allergen of product.value.allergens) {
                if (typeof allergen === 'string' && allergen.trim()) {
                    unique.add(toAllergenLabel(allergen));
                }
            }
            return Array.from(unique);
        });
        const nutritionEntries = computed(() => {
            const entries = [];
            const nutrition = product.value?.nutrition;
            if (!nutrition) {
                return entries;
            }
            for (const field of NUTRITION_FIELDS) {
                const value = nutrition[field.key];
                const formatted = formatNutritionValue(value);
                if (formatted) {
                    entries.push({ key: field.key, label: field.label, unit: field.unit, value: formatted });
                }
            }
            return entries;
        });
        const baseIngredients = computed(() => {
            if (!product.value?.ingredients || !Array.isArray(product.value.ingredients.base)) {
                return [];
            }
            const names = product.value.ingredients.base
                .map((entry) => {
                if (typeof entry === 'string') {
                    return entry.trim();
                }
                if (entry && typeof entry === 'object' && 'name' in entry) {
                    const nameValue = entry.name;
                    if (typeof nameValue === 'string') {
                        return nameValue.trim();
                    }
                }
                return '';
            })
                .filter(Boolean);
            return Array.from(new Set(names));
        });
        const currentImage = computed(() => imageGallery.value[activeImageIndex.value] || '');
        const isAvailable = computed(() => {
            if (!product.value) {
                return false;
            }
            const availabilityFlags = [product.value.available, product.value.isAvailable, product.value.isVisible];
            return availabilityFlags.every((flag) => flag !== false);
        });
        const hasValidMandatory = computed(() => {
            if (!product.value?.mandatoryIngredients) {
                return false;
            }
            return product.value.mandatoryIngredients.some((group) => {
                return Boolean(group &&
                    group.name &&
                    Array.isArray(group.ingredients) &&
                    group.ingredients.length > 0);
            });
        });
        const needsConfiguration = computed(() => {
            if (!product.value) {
                return false;
            }
            const hasExtras = Boolean(product.value.customizable &&
                Array.isArray(product.value.extraIngredients) &&
                product.value.extraIngredients.length > 0);
            const hasSizes = Boolean(product.value.hasSizes &&
                Array.isArray(product.value.sizes) &&
                product.value.sizes.length > 0);
            return hasExtras || hasSizes || hasValidMandatory.value;
        });
        const primaryActionLabel = computed(() => {
            if (!isAvailable.value) {
                return 'Nicht verfügbar';
            }
            if (needsConfiguration.value) {
                return 'Jetzt konfigurieren';
            }
            return addedFeedback.value ? 'Hinzugefügt' : 'In den Warenkorb';
        });
        const relatedSliderCategory = computed(() => {
            const slug = productCategorySlug.value || currentCategorySlug.value;
            return slug ? slugifySegment(slug) : '';
        });
        const relatedSliderKey = computed(() => {
            const categoryPart = relatedSliderCategory.value || 'all';
            const productPart = canonicalSlug.value || currentProductSlug.value || 'product';
            return `${categoryPart}-${productPart}`;
        });
        const currentImageCountWatcher = watch(imageGallery, (images) => {
            if (images.length === 0) {
                activeImageIndex.value = 0;
                return;
            }
            if (activeImageIndex.value >= images.length) {
                activeImageIndex.value = 0;
            }
        });
        const canonicalWatcher = watch(() => [product.value, canonicalSlug.value], ([productValue, canonical]) => {
            if (!productValue || !canonical) {
                return;
            }
            const currentSlug = currentProductSlug.value;
            if (!currentSlug) {
                return;
            }
            const normalizedCurrent = slugifySegment(currentSlug) || currentSlug;
            const normalizedCanonical = canonical.toLowerCase();
            if (normalizedCurrent === normalizedCanonical) {
                return;
            }
            try {
                const params = buildRouteParams(productCategorySlug.value, canonical);
                if (route.name) {
                    router.replace({
                        name: route.name,
                        params,
                        query: route.query,
                        hash: route.hash
                    });
                }
                else {
                    const pattern = route.matched?.[route.matched.length - 1]?.path;
                    if (pattern) {
                        const path = fillRoutePattern(pattern, productCategorySlug.value, canonical);
                        router.replace({ path, query: route.query, hash: route.hash });
                    }
                }
            }
            catch (error) {
                console.warn('[ProductDetailsPage] Failed to normalize route slug', error);
            }
        }, { flush: 'post' });
        function formatPrice(price, priceCent) {
            if (typeof priceCent === 'number' && Number.isInteger(priceCent)) {
                return MoneyUtils.formatCurrency(priceCent);
            }
            if (typeof price === 'number' && Number.isFinite(price)) {
                return new Intl.NumberFormat('de-DE', {
                    style: 'currency',
                    currency: 'EUR',
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                }).format(price);
            }
            return '0,00 €';
        }
        function getDepositLabel(type) {
            switch (type) {
                case 'einweg':
                    return 'Einweg';
                case 'mehrweg-klein':
                    return 'Mehrweg';
                case 'mehrweg-gross':
                    return 'Mehrweg';
                default:
                    return '';
            }
        }
        function formatLabel(value) {
            return value
                .replace(/[_-]+/g, ' ')
                .split(' ')
                .filter(Boolean)
                .map((segment) => segment.charAt(0).toUpperCase() + segment.slice(1))
                .join(' ');
        }
        function toAllergenLabel(value) {
            const key = value.toLowerCase();
            return ALLERGEN_LABELS[key] || formatLabel(value);
        }
        function formatNutritionValue(value) {
            if (value === null || value === undefined) {
                return '';
            }
            const numericValue = typeof value === 'string' ? Number(value.replace(',', '.')) : Number(value);
            if (Number.isFinite(numericValue)) {
                if (numericValue >= 10) {
                    return Math.round(numericValue).toString();
                }
                return numericValue.toFixed(1);
            }
            const stringValue = String(value).trim();
            return stringValue;
        }
        function buildImageGallery(item) {
            const urls = [];
            const imageData = item.imageData;
            // Only add the best quality image
            if (imageData && imageData.baseUrl) {
                const type = imageData.type || 'webp';
                urls.push(`${imageData.baseUrl}_original.${type}`);
            }
            else if (Array.isArray(item.images) && item.images.length > 0) {
                // If no imageData, use first image from images array
                const firstImage = item.images[0];
                if (typeof firstImage === 'string' && firstImage.trim()) {
                    urls.push(firstImage);
                }
            }
            else {
                // Fallback to legacy fields
                const legacyImage = item.image;
                if (typeof legacyImage === 'string' && legacyImage.trim()) {
                    urls.push(legacyImage.trim());
                }
                else {
                    const legacyImageUrl = item.imageUrl;
                    if (typeof legacyImageUrl === 'string' && legacyImageUrl.trim()) {
                        urls.push(legacyImageUrl.trim());
                    }
                }
            }
            return urls;
        }
        function handleImageLoadError(url) {
            removeImageFromGallery(url);
        }
        function handleThumbnailError(url) {
            removeImageFromGallery(url);
        }
        function removeImageFromGallery(url) {
            if (!url) {
                return;
            }
            const filtered = imageGallery.value.filter((image) => image !== url);
            imageGallery.value = filtered;
            if (activeImageIndex.value >= filtered.length) {
                activeImageIndex.value = filtered.length > 0 ? filtered.length - 1 : 0;
            }
        }
        function handleAddToCart() {
            if (!product.value || !isAvailable.value) {
                return;
            }
            if (needsConfiguration.value) {
                openConfigModal();
                return;
            }
            cartStore.addItem(product.value);
            addedFeedback.value = true;
            if (addFeedbackTimer !== null && typeof window !== 'undefined') {
                window.clearTimeout(addFeedbackTimer);
            }
            if (typeof window !== 'undefined') {
                addFeedbackTimer = window.setTimeout(() => {
                    addedFeedback.value = false;
                    addFeedbackTimer = null;
                }, 1800);
            }
        }
        function openConfigModal() {
            if (!product.value) {
                return;
            }
            modalProduct.value = product.value;
            isConfigModalOpen.value = true;
        }
        function closeConfigModal() {
            isConfigModalOpen.value = false;
        }
        function handleConfiguredProductAdd(configuredItem) {
            cartStore.addItem(configuredItem);
            isConfigModalOpen.value = false;
            modalProduct.value = null;
            addedFeedback.value = true;
            if (addFeedbackTimer !== null && typeof window !== 'undefined') {
                window.clearTimeout(addFeedbackTimer);
            }
            if (typeof window !== 'undefined') {
                addFeedbackTimer = window.setTimeout(() => {
                    addedFeedback.value = false;
                    addFeedbackTimer = null;
                }, 1800);
            }
        }
        function handleBack() {
            if (typeof window !== 'undefined') {
                if (window.history.length > 1) {
                    window.history.back();
                }
                else {
                    // If no history, navigate to home
                    window.location.href = '/';
                }
            }
        }
        function retryLoad() {
            void loadProduct();
        }
        function handleRelatedProductSelect(item) {
            console.log('[ProductDetailsPage] handleRelatedProductSelect:', {
                item,
                itemId: item._id || item.id,
                name: item.name,
                categorySlug: item.categorySlug,
                categoryName: item.categoryName,
                category: item.category
            });
            const targetRoute = getProductLink(item);
            console.log('[ProductDetailsPage] Generated route:', targetRoute);
            // Use window.location for navigation to avoid router injection issues
            if (typeof targetRoute === 'object' && targetRoute.path) {
                window.location.href = targetRoute.path;
            }
        }
        function getProductLink(item) {
            const itemId = item._id || item.id;
            const productId = itemId ? String(itemId) : '';
            const productSlug = generateProductSlug(item);
            const targetCategory = getCategorySlugFromProduct(item) || productCategorySlug.value || currentCategorySlug.value;
            if (!productSlug || !productId) {
                console.warn('[ProductDetailsPage] Missing slug or ID for product:', item.name);
                // Fallback to current page without query params
                return { path: window.location.pathname };
            }
            // Build path: /produkte/category/slug/id
            const categorySegment = targetCategory ? `${slugifySegment(targetCategory)}/` : '';
            const finalPath = `/produkte/${categorySegment}${productSlug}/${productId}`;
            return {
                path: finalPath
            };
        }
        function buildRouteParams(categorySlug, productSlug, productId) {
            const params = {};
            const fallbackCategory = (typeof route.params.categorySlug === 'string' && route.params.categorySlug) ||
                (typeof route.params.category === 'string' && route.params.category) ||
                '';
            const resolvedCategory = categorySlug ?? fallbackCategory;
            if (resolvedCategory && ('categorySlug' in route.params || !('category' in route.params))) {
                params.categorySlug = resolvedCategory;
            }
            if ('category' in route.params) {
                params.category = resolvedCategory;
            }
            if ('productSlug' in route.params || !('product' in route.params)) {
                params.productSlug = productSlug;
            }
            if ('product' in route.params) {
                params.product = productSlug;
            }
            if (productId) {
                if ('productId' in route.params) {
                    params.productId = productId;
                }
                if ('id' in route.params) {
                    params.id = productId;
                }
            }
            for (const key of Object.keys(route.params)) {
                if (key in params) {
                    continue;
                }
                const value = route.params[key];
                if (typeof value === 'string') {
                    params[key] = value;
                }
                else if (Array.isArray(value)) {
                    const normalized = value.filter((entry) => typeof entry === 'string');
                    if (normalized.length > 0) {
                        params[key] = normalized;
                    }
                }
            }
            return params;
        }
        function fillRoutePattern(pattern, categorySlug, productSlug, productId) {
            const fallbackCategory = (typeof route.params.categorySlug === 'string' && route.params.categorySlug) ||
                (typeof route.params.category === 'string' && route.params.category) ||
                '';
            const resolvedCategory = categorySlug ? slugifySegment(categorySlug) : fallbackCategory;
            let result = pattern
                .replace(/:categorySlug\??/g, resolvedCategory)
                .replace(/:category\??/g, resolvedCategory)
                .replace(/:productSlug\??/g, productSlug)
                .replace(/:product\??/g, productSlug);
            if (productId) {
                result = result
                    .replace(/:productId\??/g, productId)
                    .replace(/:id\??/g, productId);
            }
            return result.replace(/\/+/g, '/');
        }
        function findProductBySlug(slug, categorySlug, productId) {
            // Priority 1: Find by exact product ID if provided
            if (productId) {
                const byId = menuItemsList.value.find((item) => {
                    if (typeof item._id === 'string') {
                        return item._id === productId;
                    }
                    if (item._id && typeof item._id === 'object') {
                        const idObj = item._id;
                        return idObj.toString() === productId;
                    }
                    return false;
                });
                if (byId) {
                    return byId;
                }
            }
            // Priority 2: Find by slug matching
            const normalizedSlug = slugifySegment(slug) || slug.toLowerCase();
            const normalizedCategory = slugifySegment(categorySlug);
            for (const item of menuItemsList.value) {
                const candidateSlugs = getProductSlugCandidates(item).map((candidate) => candidate.toLowerCase());
                if (!candidateSlugs.includes(normalizedSlug)) {
                    continue;
                }
                if (!normalizedCategory) {
                    return item;
                }
                const itemCategory = getCategorySlugFromProduct(item);
                if (!itemCategory || slugifySegment(itemCategory) === normalizedCategory) {
                    return item;
                }
            }
            return null;
        }
        async function loadProduct() {
            const slug = currentProductSlug.value;
            if (!slug) {
                product.value = null;
                imageGallery.value = [];
                loadError.value = 'Produkt konnte nicht identifiziert werden.';
                loading.value = false;
                return;
            }
            const category = currentCategorySlug.value;
            const productId = currentProductId.value;
            const loadToken = ++loadSequence;
            loading.value = true;
            loadError.value = null;
            try {
                if (menuItemsList.value.length === 0) {
                    await loadMenuBundle();
                }
                if (loadToken !== loadSequence) {
                    return;
                }
                const matched = findProductBySlug(slug, category, productId);
                if (!matched) {
                    product.value = null;
                    imageGallery.value = [];
                    loadError.value = 'Produkt wurde leider nicht gefunden.';
                    return;
                }
                product.value = matched;
                imageGallery.value = buildImageGallery(matched);
                activeImageIndex.value = 0;
            }
            catch (error) {
                console.error('[ProductDetailsPage] Failed to load product', error);
                product.value = null;
                imageGallery.value = [];
                loadError.value = 'Beim Laden des Produkts ist ein Fehler aufgetreten.';
            }
            finally {
                if (loadToken === loadSequence) {
                    loading.value = false;
                }
            }
        }
        watch(() => [currentProductSlug.value, currentCategorySlug.value], () => {
            // Smooth scroll to top when product changes
            window.scrollTo({ top: 0, behavior: 'smooth' });
            void loadProduct();
        });
        watch(isConfigModalOpen, (isOpen) => {
            if (!isOpen) {
                modalProduct.value = null;
            }
        });
        onMounted(() => {
            // Smooth scroll to top when page loads
            window.scrollTo({ top: 0, behavior: 'smooth' });
            void loadProduct();
        });
        onBeforeUnmount(() => {
            if (addFeedbackTimer !== null && typeof window !== 'undefined') {
                window.clearTimeout(addFeedbackTimer);
            }
            currentImageCountWatcher();
            canonicalWatcher();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", { class: "mb-8" }, [
                            _createElementVNode("button", {
                                type: "button",
                                class: "inline-flex items-center gap-2 rounded-full border border-gray-200 bg-white px-4 py-2 text-sm font-medium text-gray-600 shadow-sm transition hover:border-gray-300 hover:text-gray-800",
                                onClick: handleBack
                            }, [...(_cache[1] || (_cache[1] = [
                                    _createElementVNode("svg", {
                                        class: "h-5 w-5",
                                        fill: "none",
                                        stroke: "currentColor",
                                        "stroke-width": "1.5",
                                        viewBox: "0 0 24 24"
                                    }, [
                                        _createElementVNode("path", {
                                            d: "M15 19l-7-7 7-7",
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round"
                                        })
                                    ], -1 /* CACHED */),
                                    _createTextVNode(" Zurück ", -1 /* CACHED */)
                                ]))])
                        ]),
                        (loading.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[2] || (_cache[2] = [
                                    _createElementVNode("div", { class: "h-10 w-10 animate-spin rounded-full border-2 border-gray-300 border-t-red-500" }, null, -1 /* CACHED */),
                                    _createElementVNode("span", { class: "mt-4 text-lg font-medium" }, "Produkt wird geladen...", -1 /* CACHED */),
                                    _createElementVNode("span", { class: "mt-2 text-sm text-gray-400" }, "Bitte einen Moment Geduld.", -1 /* CACHED */)
                                ]))]))
                            : (loadError.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                    _createElementVNode("h1", _hoisted_5, _toDisplayString(loadError.value), 1 /* TEXT */),
                                    _cache[3] || (_cache[3] = _createElementVNode("p", { class: "mt-2 text-gray-500" }, "Versuche es bitte erneut oder kehre zur Übersicht zurück.", -1 /* CACHED */)),
                                    _createElementVNode("div", { class: "mt-6 flex flex-wrap justify-center gap-3" }, [
                                        _createElementVNode("button", {
                                            type: "button",
                                            class: "inline-flex items-center gap-2 rounded-full border border-gray-200 bg-white px-4 py-2 text-sm font-medium text-gray-600 shadow-sm transition hover:border-gray-300 hover:text-gray-800",
                                            onClick: retryLoad
                                        }, " Erneut versuchen "),
                                        _createElementVNode("button", {
                                            type: "button",
                                            class: "inline-flex items-center gap-2 rounded-full border border-transparent bg-red-600 px-4 py-2 text-sm font-semibold text-white shadow-sm transition hover:bg-red-700",
                                            onClick: handleBack
                                        }, " Zur Übersicht ")
                                    ])
                                ]))
                                : (product.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                        _createCommentVNode(" Product Image "),
                                        _createElementVNode("div", _hoisted_7, [
                                            _createElementVNode("div", _hoisted_8, [
                                                _createElementVNode("div", _hoisted_9, [
                                                    (currentImage.value)
                                                        ? (_openBlock(), _createElementBlock("img", {
                                                            key: 0,
                                                            src: currentImage.value,
                                                            alt: product.value.name,
                                                            class: "h-full w-full object-contain",
                                                            onError: _cache[0] || (_cache[0] = ($event) => (handleImageLoadError(currentImage.value)))
                                                        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_10))
                                                        : (_openBlock(), _createElementBlock("div", _hoisted_11, [...(_cache[4] || (_cache[4] = [
                                                                _createStaticVNode("<svg class=\"h-16 w-16 text-gray-300\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.5\" viewBox=\"0 0 24 24\" data-v-080082d4><rect x=\"3\" y=\"3\" width=\"18\" height=\"18\" rx=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-080082d4></rect><circle cx=\"9\" cy=\"9\" r=\"2.5\" data-v-080082d4></circle><path d=\"M21 16l-5-5-6 7h11\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-080082d4></path></svg><span class=\"mt-4 text-sm\" data-v-080082d4>Kein Bild verfügbar</span>", 2)
                                                            ]))]))
                                                ])
                                            ]),
                                            _createCommentVNode(" Show thumbnails only if there are multiple images "),
                                            (imageGallery.value.length > 1)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(imageGallery.value, (image, index) => {
                                                        return (_openBlock(), _createElementBlock("button", {
                                                            key: image,
                                                            type: "button",
                                                            class: _normalizeClass(["group relative aspect-square overflow-hidden rounded-lg border-2 bg-white shadow-sm transition", index === activeImageIndex.value ? 'border-pink-500 ring-2 ring-pink-200' : 'border-gray-200 hover:border-pink-300']),
                                                            onClick: ($event) => (activeImageIndex.value = index)
                                                        }, [
                                                            _createElementVNode("img", {
                                                                src: image,
                                                                alt: "",
                                                                class: "h-full w-full object-contain p-1",
                                                                onError: ($event) => (handleThumbnailError(image))
                                                            }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_14)
                                                        ], 10 /* CLASS, PROPS */, _hoisted_13));
                                                    }), 128 /* KEYED_FRAGMENT */))
                                                ]))
                                                : _createCommentVNode("v-if", true)
                                        ]),
                                        _createCommentVNode(" Product Info "),
                                        _createElementVNode("div", _hoisted_15, [
                                            _createCommentVNode(" Brand above title "),
                                            (brand.value)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(brand.value), 1 /* TEXT */))
                                                : _createCommentVNode("v-if", true),
                                            _createCommentVNode(" Product Name "),
                                            _createElementVNode("h1", _hoisted_17, _toDisplayString(product.value.name), 1 /* TEXT */),
                                            _createCommentVNode(" Badges (Category & Weight) "),
                                            _createElementVNode("div", _hoisted_18, [
                                                (categoryLabel.value)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(categoryLabel.value), 1 /* TEXT */))
                                                    : _createCommentVNode("v-if", true),
                                                (weight.value)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(weight.value), 1 /* TEXT */))
                                                    : _createCommentVNode("v-if", true)
                                            ]),
                                            _createCommentVNode(" Description "),
                                            (shortDescription.value)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(shortDescription.value), 1 /* TEXT */))
                                                : (product.value.description)
                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_22, _toDisplayString(product.value.description), 1 /* TEXT */))
                                                    : _createCommentVNode("v-if", true),
                                            _createElementVNode("div", _hoisted_23, [
                                                _createElementVNode("span", _hoisted_24, _toDisplayString(formattedPrice.value), 1 /* TEXT */),
                                                (hasDiscount.value && formattedOriginalPrice.value)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(formattedOriginalPrice.value), 1 /* TEXT */))
                                                    : _createCommentVNode("v-if", true),
                                                (discountPercent.value)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_26, " -" + _toDisplayString(discountPercent.value) + "% ", 1 /* TEXT */))
                                                    : _createCommentVNode("v-if", true)
                                            ]),
                                            (depositDisplay.value)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                                    _createTextVNode(" zzgl. " + _toDisplayString(depositDisplay.value.amount) + " Pfand", 1 /* TEXT */),
                                                    (depositDisplay.value.label)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_28, " (" + _toDisplayString(depositDisplay.value.label) + ")", 1 /* TEXT */))
                                                        : _createCommentVNode("v-if", true)
                                                ]))
                                                : _createCommentVNode("v-if", true),
                                            (ean.value)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                                    _cache[5] || (_cache[5] = _createTextVNode(" EAN: ", -1 /* CACHED */)),
                                                    _createElementVNode("span", _hoisted_30, _toDisplayString(ean.value), 1 /* TEXT */)
                                                ]))
                                                : _createCommentVNode("v-if", true),
                                            _createElementVNode("div", _hoisted_31, [
                                                _createElementVNode("button", {
                                                    type: "button",
                                                    class: "w-full rounded-full px-6 py-3.5 text-base font-semibold text-white shadow-lg transition hover:opacity-90 disabled:cursor-not-allowed disabled:bg-gray-300 disabled:text-gray-500",
                                                    style: _normalizeStyle(!isAvailable.value ? {} : { backgroundColor: primaryColor.value }),
                                                    disabled: !isAvailable.value,
                                                    onClick: handleAddToCart
                                                }, [
                                                    (!isAvailable.value)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_33, "Aktuell nicht verfügbar"))
                                                        : (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(primaryActionLabel.value), 1 /* TEXT */))
                                                ], 12 /* STYLE, PROPS */, _hoisted_32),
                                                (addedFeedback.value && !needsConfiguration.value)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_35, "✓ Zum Warenkorb hinzugefügt"))
                                                    : _createCommentVNode("v-if", true)
                                            ]),
                                            (keywords.value.length)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                                    _cache[6] || (_cache[6] = _createElementVNode("h2", { class: "text-sm font-semibold uppercase tracking-wide text-gray-500" }, "Highlights", -1 /* CACHED */)),
                                                    _createElementVNode("div", _hoisted_37, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(keywords.value, (keyword) => {
                                                            return (_openBlock(), _createElementBlock("span", {
                                                                key: keyword,
                                                                class: "rounded-full bg-gray-200 px-3 py-1 text-sm text-gray-700"
                                                            }, _toDisplayString(keyword), 1 /* TEXT */));
                                                        }), 128 /* KEYED_FRAGMENT */))
                                                    ])
                                                ]))
                                                : _createCommentVNode("v-if", true),
                                            (allergens.value.length)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                                    _cache[7] || (_cache[7] = _createElementVNode("h2", { class: "text-sm font-semibold uppercase tracking-wide text-gray-500" }, "Allergene", -1 /* CACHED */)),
                                                    _createElementVNode("div", _hoisted_39, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allergens.value, (allergen) => {
                                                            return (_openBlock(), _createElementBlock("span", {
                                                                key: allergen,
                                                                class: "rounded-full border border-red-200 px-3 py-1 text-sm text-red-600"
                                                            }, _toDisplayString(allergen), 1 /* TEXT */));
                                                        }), 128 /* KEYED_FRAGMENT */))
                                                    ])
                                                ]))
                                                : _createCommentVNode("v-if", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_40, [
                                            _createElementVNode("div", _hoisted_41, [
                                                (nutritionEntries.value.length)
                                                    ? (_openBlock(), _createElementBlock("section", _hoisted_42, [
                                                        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "flex items-center justify-between" }, [
                                                            _createElementVNode("h2", { class: "text-lg font-semibold text-gray-900" }, "Nährwerte (je 100 g / ml)"),
                                                            _createElementVNode("span", { class: "text-sm text-gray-400" }, "Angaben ohne Gewähr")
                                                        ], -1 /* CACHED */)),
                                                        _createElementVNode("div", _hoisted_43, [
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nutritionEntries.value, (entry) => {
                                                                return (_openBlock(), _createElementBlock("div", {
                                                                    key: entry.key,
                                                                    class: "rounded-2xl border border-gray-100 bg-gray-50 p-4 text-center shadow-sm"
                                                                }, [
                                                                    _createElementVNode("div", _hoisted_44, _toDisplayString(entry.label), 1 /* TEXT */),
                                                                    _createElementVNode("div", _hoisted_45, [
                                                                        _createTextVNode(_toDisplayString(entry.value) + " ", 1 /* TEXT */),
                                                                        _createElementVNode("span", _hoisted_46, _toDisplayString(entry.unit), 1 /* TEXT */)
                                                                    ])
                                                                ]));
                                                            }), 128 /* KEYED_FRAGMENT */))
                                                        ])
                                                    ]))
                                                    : _createCommentVNode("v-if", true),
                                                (baseIngredients.value.length)
                                                    ? (_openBlock(), _createElementBlock("section", _hoisted_47, [
                                                        _cache[9] || (_cache[9] = _createElementVNode("h2", { class: "text-lg font-semibold text-gray-900" }, "Zutaten", -1 /* CACHED */)),
                                                        _createElementVNode("p", _hoisted_48, _toDisplayString(baseIngredients.value.join(', ')), 1 /* TEXT */)
                                                    ]))
                                                    : _createCommentVNode("v-if", true)
                                            ])
                                        ])
                                    ]))
                                    : _createCommentVNode("v-if", true)
                    ]),
                    _createCommentVNode(" Product Slider - Full width outside max-w container "),
                    (relatedSliderCategory.value)
                        ? (_openBlock(), _createElementBlock("section", _hoisted_49, [
                            (_openBlock(), _createBlock(ProductSlider, {
                                key: relatedSliderKey.value,
                                title: "Weitere Produkte aus dieser Kategorie",
                                categorySlug: relatedSliderCategory.value || undefined,
                                limit: 8,
                                variant: "minimal",
                                lazy: false,
                                exclude: [currentProductId.value],
                                onProductSelected: handleRelatedProductSelect
                            }, null, 8 /* PROPS */, ["categorySlug", "exclude"]))
                        ]))
                        : _createCommentVNode("v-if", true)
                ]),
                (modalProduct.value)
                    ? (_openBlock(), _createBlock(ProductConfigModal, {
                        key: 0,
                        isOpen: isConfigModalOpen.value,
                        product: modalProduct.value,
                        onClose: closeConfigModal,
                        onAddToCart: handleConfiguredProductAdd
                    }, null, 8 /* PROPS */, ["isOpen", "product"]))
                    : _createCommentVNode("v-if", true)
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
